import React from "react";
import { Instagram } from "lucide-react";
import { ytEmbed } from "../../lib/constants";

/**
 * Reels strip — up to 4 vertical (9:16) YouTube reels that always autoplay
 * (muted, looping), shown in a single row. On mobile they stay in a line via a
 * horizontal scroll so the layout matches the reference. A centred
 * "More reels on Instagram" button links out to the Instagram profile.
 */
export default function InstagramReels({ reels = [], instagramUrl = "https://www.instagram.com/swayambhugold/", handle = "swayambhugold" }) {
  const items = (reels || []).map((r) => (typeof r === "string" ? r : r.youtube_url)).filter(Boolean).slice(0, 4);
  if (!items.length) return null;

  return (
    <section className="hidden sm:block px-6 lg:px-12 py-20 bg-gradient-to-b from-white to-pearl" data-testid="instagram-reels">
      <div className="text-center mb-10 reveal">
        <div className="eyebrow inline-flex items-center gap-2 justify-center">
          <Instagram size={14} /> Follow us
        </div>
        <h2 className="font-display text-4xl lg:text-5xl text-maroon mt-1">@{handle}</h2>
        <p className="text-ash mt-2 text-sm">Reels from the showroom floor and the karigar's bench.</p>
      </div>

      {/* One row of 4 reels — horizontal scroll on mobile, 4-up on desktop */}
      <div className="max-w-6xl mx-auto">
        <div className="flex gap-4 overflow-x-auto sm:grid sm:grid-cols-2 lg:grid-cols-4 sm:overflow-visible pb-2 snap-x">
          {items.map((url, i) => (
            <div
              key={i}
              className="relative shrink-0 w-[68%] sm:w-auto aspect-[9/16] rounded-2xl overflow-hidden border border-line bg-black snap-center shadow-sm"
              data-testid={`reel-${i}`}
            >
              <iframe
                src={ytEmbed(url, { loop: true, controls: false })}
                title={`Reel ${i + 1}`}
                className="absolute inset-0 w-full h-full"
                frameBorder="0"
                allow="autoplay; encrypted-media; picture-in-picture"
                allowFullScreen
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Centred CTA to Instagram */}
      <div className="text-center mt-8 reveal">
        <a
          href={instagramUrl || `https://www.instagram.com/${handle}/`}
          target="_blank"
          rel="noreferrer"
          className="btn-maroon inline-flex"
          data-testid="instagram-follow"
        >
          <Instagram size={14} className="mr-2" /> More reels on Instagram
        </a>
      </div>
    </section>
  );
}
